import { types } from 'mobx-state-tree';

export const PolicySelectedOptions = types.model('PolicySelectedOptions', {
  code: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  shippingPolicyCode: types.optional(types.string, ''),
  paymentPolicyCode: types.optional(types.string, ''),
  returnsPolicyCode: types.optional(types.string, ''),
}).actions(self=>({
  setName(name){
    self.name=name;
  },
  setShippingPolicyCode(code){
    self.shippingPolicyCode=code;
  },
  setPaymentPolicyCode(code){
    self.paymentPolicyCode=code;
  },
  setReturnsPolicyCode(code){
    self.returnsPolicyCode=code;
  }

}));
